import '@fontsource/klee-one/600.css'; // font-family: 'Klee One';
import '@fontsource/m-plus-1p/400.css'; // font-family: 'M PLUS 1p';
import '@fontsource/fira-sans/400.css'; // font-family: 'Fira Sans';

export const baseFontFamily = "'M PLUS 1p', sans-serif";
export const baseFontSize = "13px";
export const baseLineHeight = 1.5;

export const primaryFontFamily = "'Klee One', sans-serif";

export const accentFontFamily = "'Fira Sans', sans-serif";
